import React from "react";
import classNames from "classnames";
import { Icon } from "armstrong-react";

import { SvgIcon } from "./../../../core/atoms/atoms";

export interface PanelDefinition {
  render: (isOpen: boolean, onClick: () => void) => JSX.Element;
}

interface AccordionProps {
  panels: PanelDefinition[];
}

interface State {
  activeIndex: number;
}

export class Accordion extends React.Component<AccordionProps, State> {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    }; 
  }

  public openDrawer = (index: number) => {
    if (this.state.activeIndex !== index) {
      this.setState({
        activeIndex: index
      });
    }
  }

  private toggleDrawer = (index: number) => {
    this.setState({
      activeIndex: this.state.activeIndex !== index ? index : null
    });
  }

  public render() {
    return (
      <div className="accordion">
        {this.props.panels.map((element, i) => {
          return element.render(this.state.activeIndex === i, () => this.toggleDrawer(i));
        })}
      </div>
    );
  }
}

interface DrawerProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  clearFilters: () => void;
  activeCount: number;
  maxCount: number;
  svg: string;
}

export class FilterPanel extends React.Component<DrawerProps, {}> {
  constructor(props) {
    super(props);
    this.state = {
    }; 
  }

  private handleBubbleClick = () => {
    if (this.props.activeCount > 0 && this.props.clearFilters) {
      this.props.clearFilters();
    }
    else {
      this.props.onToggle();
    }
  }

  public render() {
    let title = this.props.title.toLocaleLowerCase();
    let isShowingAll = this.props.activeCount < 1 || this.props.activeCount >= this.props.maxCount;
    let canClearFilters = this.props.activeCount > 0;
    let headerTitleText = `Showing inspiration for ${isShowingAll ? "all" : this.props.activeCount} ${title}`;

    return (
      <div key={`panel-${title}`} className={classNames("filter-drawer", { "open": this.props.isOpen })}>
        <header onClick={e => { if (this.props.onToggle) this.props.onToggle() }} title={headerTitleText}>
          <h2>
            {this.props.title} <Icon icon={this.props.isOpen ? Icon.Icomoon.arrowUp4 : Icon.Icomoon.arrowDown4} />
          </h2>
          <div className={classNames("count-bubble", { "showing-all": isShowingAll, "can-clear": canClearFilters })}
               title={canClearFilters ? `Click to remove filters for ${title} and show other inspiration` : headerTitleText}
               onClick={e => { e.stopPropagation(); this.handleBubbleClick() }}>
            <SvgIcon svg={this.props.svg} />
            {isShowingAll ? "all" : this.props.activeCount}
            {canClearFilters && <Icon icon={Icon.Icomoon.cross} />}
          </div>
        </header>
        
        {this.props.children}
      </div>
    );
  }
}
